import { render, staticRenderFns } from "./TabGeneral.vue?vue&type=template&id=c41f4aa8&"
import script from "./TabGeneral.vue?vue&type=script&lang=ts&"
export * from "./TabGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c41f4aa8', component.options)
    } else {
      api.reload('c41f4aa8', component.options)
    }
    module.hot.accept("./TabGeneral.vue?vue&type=template&id=c41f4aa8&", function () {
      api.rerender('c41f4aa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/BajasCobranza/gridActions/tabs/TabGeneral.vue"
export default component.exports